import { Author } from "../../../../Common/objects/author";
import { PictureType, PictureTypes } from "./pictureState";

export type Picture = {
    description?: null | string,
    id: number,
    alt?: string,
    credits?: string,
    type: PictureType,
    name?: null | string,
    compressed_picture?: null | string,
    thumbnail_big?: null | string,
    thumbnail_little?: null | string,
    thumbnail_medium?: null | string,
    url: null | string,
    creator: Author | null,
    last_author: Author | null,
    created_date: string,
    modified_date: string,
    localization: {
        locale: number,
        name: string
    }[] | null
}

export interface PictureForm {
    description?: null | string,
    alt?: string | null,
    credits?: string | null,
    type: PictureType,
    name?: null | string,
    file: null | any,
}


export const EMPTY_PICTURE_FORM: PictureForm = {
    description: null,
    alt: null,
    credits: null,
    type: PictureTypes[0],
    name: null,
    file: null,
};
